import aiAgents from './ai-agents.json';
import aiAgent from './ai-agent/ai-agent.json';
import analytics from './analytics/analytics.json';
import auth from './auth.json';
import billing from './billing.json';
import channels from './channels/channels.json';
import common from './common.json';
import dialogs from './dialogs.json';
import integrations from './integrations.json';
import knowledgeBase from './knowledge-base.json';
import messages from './messages.json';
import profile from './profile.json';
import prompt from './ai-agent/prompt.json';
import sidebar from './sidebar/sidebar.json';
import team from './team.json';
import presets from './presets.json';
import preview from './preview.json';

export default {
  aiAgent,
  aiAgents,
  analytics,
  auth,
  billing,
  channels,
  common,
  dialogs,
  integrations,
  knowledgeBase,
  messages,
  profile,
  prompt,
  sidebar,
  team,
  presets,
  preview,
};
